/**
 * Company Dialog Component - Modal for Create/Edit companies
 */

import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { SupabaseCompany } from '@/hooks/useSupabaseCompanies';
import { CompanyForm } from './CompanyForm';

interface CompanyDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  company?: SupabaseCompany;
  mode: 'create' | 'edit';
}

export const CompanyDialog: React.FC<CompanyDialogProps> = ({
  open,
  onOpenChange,
  company,
  mode
}) => {
  const handleSuccess = () => {
    onOpenChange(false);
  };

  const handleCancel = () => {
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>
            {mode === 'create' ? 'Tạo công ty mới' : 'Sửa thông tin công ty'}
          </DialogTitle>
          <DialogDescription>
            {mode === 'create' 
              ? 'Nhập thông tin để tạo công ty mới trong hệ thống'
              : 'Cập nhật thông tin công ty'
            }
          </DialogDescription>
        </DialogHeader>
        
        <CompanyForm
          company={company}
          onSuccess={handleSuccess}
          onCancel={handleCancel}
        />
      </DialogContent>
    </Dialog>
  );
};